var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpAcademyS6Line1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 40,
    viewBox: "0 0 194 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19L1.93508e-06 14.2265L1.99805e-06 25.7735L10 21L10 19ZM184 21L194 25.7735L194 14.2265L184 19L184 21ZM20.7857 20L20.7857 21L34.6429 21L34.6429 20L34.6429 19L20.7857 19L20.7857 20ZM48.5 20L48.5 21L62.3571 21L62.3571 20L62.3571 19L48.5 19L48.5 20ZM76.2143 20L76.2143 21L90.0714 21L90.0714 20L90.0714 19L76.2143 19L76.2143 20ZM103.929 20L103.929 21L117.786 21L117.786 20L117.786 19L103.929 19L103.929 20ZM131.643 20L131.643 21L145.5 21L145.5 20L145.5 19L131.643 19L131.643 20ZM159.357 20L159.357 21L173.214 21L173.214 20L173.214 19L159.357 19L159.357 20Z",
    fill: "#B9B9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpAcademyS6Line1);
export default __webpack_public_path__ + "static/media/lp_academy_s6_line1.08448eef241e70be84e2489f969d0ea4.svg";
export { ForwardRef as ReactComponent };